import { render, staticRenderFns } from "./Clock.vue?vue&type=template&id=5c16e7e5"
import script from "./Clock.vue?vue&type=script&lang=js"
export * from "./Clock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports